import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)
import createPersistedState from "vuex-persistedstate";
const userState = createPersistedState({
  paths: ['userInfo']
})
export default new Vuex.Store({
  state: {
    userInfo:{}
  },
  mutations: {
    SET_USER_INFO: (state, data) => {
      state.userInfo = data
    },
  },
  actions: {
  },
  modules: {
  },
  plugins: [userState]
})
